'use client';

import { cn } from '@utils';
import { tv } from 'tailwind-variants';

import { LoadingSpinnerIcon } from '../icons';

interface LoadingSpinnerProps {
	theme?: 'light' | 'dark';
	label?: string;
	position?: 'right' | 'bottom';
	size?: 'large' | 'small';
	className?: string;
}

export const LoadingSpinner = ({
	theme,
	label,
	position = 'right',
	size = 'large',
	className,
}: LoadingSpinnerProps) => {
	const iconStyle = tv({
		base: 'text-light-design-accent animate-spin',
		variants: {
			size: {
				large: 'size-icon-lg',
				small: 'size-icon-sm',
			},
		},
		defaultVariants: {
			size: 'large',
		},
	});

	const containerStyle = tv({
		base: 'flex items-center justify-center gap-4',
		variants: {
			position: {
				right: 'flex-row',
				bottom: 'flex-col',
			},
		},
		defaultVariants: {
			position: 'bottom',
		},
	});

	const labelStyle = tv({
		base: 'font-semibold',
		variants: {
			theme: {
				light: 'text-light-heading',
				dark: 'text-dark-heading',
			},
		},
		defaultVariants: {
			theme: 'light',
		},
	});

	return (
		<div className={cn(containerStyle({ position }), className)}>
			<LoadingSpinnerIcon className={cn(iconStyle({ size }), className)} />
			{label && <p className={labelStyle({ theme })}>{label}</p>}
		</div>
	);
};
